module.exports = __webpack_public_path__ + "assets/img/14_899_big.8477c39a.jpg";